export const getBookingDetailsFromLocalStorage = (): string | null => {
  const bookingDetails = localStorage.getItem("bookingDetails");
  if (bookingDetails) {
    try {
      const parsedDetails = JSON.parse(bookingDetails);
      return parsedDetails?.booking_id || null;
    } catch (error) {
      console.error("Error parsing booking details from localStorage:", error);
      return null;
    }
  }
  return null;
};